export default __webpack_public_path__ + "static/media/pitch-video-best-practices-a-integrer-crazy-6-etape3-boite-outil.4a3b0b33.pdf";